
require("./../../node_modules/@module-federation/nextjs-mf/src/include-defaults.js");
// Generated by ReScript, PLEASE EDIT WITH CARE

import * as BsCss from "../bindings/BsCss.bs.js";
import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as Theme from "../css/Theme.bs.js";
import * as SeoMeta from "../components/library/SeoMeta.bs.js";
import * as Belt_Array from "@rescript/std/lib/es6/belt_Array.js";
import * as AboutHeader from "../components/pages/about/AboutHeader.bs.js";
import * as Belt_Option from "@rescript/std/lib/es6/belt_Option.js";
import * as MeetTheTeam from "../components/pages/about/MeetTheTeam.bs.js";
import * as MediaSection from "../components/pages/about/shoutAbout/MediaSection.bs.js";
import * as AboutJoinTeam from "../components/pages/about/AboutJoinTeam.bs.js";
import * as OurValueSection from "../components/pages/about/ourValue/OurValueSection.bs.js";
import * as WhoWeAreSection from "../components/pages/about/whoWeAre/WhoWeAreSection.bs.js";
import * as OurJourneySection from "../components/pages/about/ourJourney/OurJourneySection.bs.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as EnrichedTextSection from "../components/enrichedTextSection/EnrichedTextSection.bs.js";
import * as PageContentResolver from "../utils/PageContentResolver.bs.js";
import * as BoardOfDirectorsSection from "../components/pages/about/BoardOfDirectorsSection.bs.js";
import * as TrustpilotWidgetSection from "../components/TrustpilotWidgetSection.bs.js";

var whoWeAreContainer = Curry._1(BsCss.style, {
      hd: BsCss.maxWidth(BsCss.px(1200)),
      tl: {
        hd: BsCss.backgroundColor(Theme.Color.white),
        tl: {
          hd: BsCss.marginLeft("auto"),
          tl: {
            hd: BsCss.marginRight("auto"),
            tl: {
              hd: BsCss.marginTop(BsCss.px(63)),
              tl: {
                hd: BsCss.marginBottom(BsCss.px(63)),
                tl: {
                  hd: BsCss.media("(min-width: 768px) and (max-width: 1023px)", {
                        hd: BsCss.marginTop(BsCss.px(58)),
                        tl: {
                          hd: BsCss.marginBottom(BsCss.px(58)),
                          tl: /* [] */0
                        }
                      }),
                  tl: {
                    hd: BsCss.media("(min-width: 1024px) and (max-width: 1279px)", {
                          hd: BsCss.marginTop(BsCss.px(94)),
                          tl: {
                            hd: BsCss.marginBottom(BsCss.px(94)),
                            tl: /* [] */0
                          }
                        }),
                    tl: {
                      hd: BsCss.media("(min-width: 1280px) and (max-width: 1439px)", {
                            hd: BsCss.marginTop(BsCss.px(84)),
                            tl: {
                              hd: BsCss.marginBottom(BsCss.px(84)),
                              tl: /* [] */0
                            }
                          }),
                      tl: {
                        hd: BsCss.media("(min-width: 1440px)", {
                              hd: BsCss.marginTop(BsCss.px(97)),
                              tl: {
                                hd: BsCss.marginBottom(BsCss.px(97)),
                                tl: /* [] */0
                              }
                            }),
                        tl: /* [] */0
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    });

var container = Curry._1(BsCss.style, {
      hd: BsCss.maxWidth(BsCss.px(1200)),
      tl: {
        hd: BsCss.backgroundColor(Theme.Color.white),
        tl: {
          hd: BsCss.marginLeft("auto"),
          tl: {
            hd: BsCss.marginRight("auto"),
            tl: {
              hd: BsCss.marginTop(BsCss.px(30)),
              tl: {
                hd: BsCss.marginBottom(BsCss.px(30)),
                tl: /* [] */0
              }
            }
          }
        }
      }
    });

var Styles = {
  whoWeAreContainer: whoWeAreContainer,
  container: container
};

function About(props) {
  var pageContent = PageContentResolver.parse(props.content);
  var f = function (idx, v) {
    var key = String(idx);
    if (typeof v !== "object") {
      return null;
    }
    var variant = v.NAME;
    if (variant === "BoardOfDirectorsBlock") {
      return JsxRuntime.jsx(BoardOfDirectorsSection.make, {
                  block: v.VAL
                }, key);
    } else if (variant === "TrustpilotWidgetBlock") {
      return JsxRuntime.jsx(TrustpilotWidgetSection.make, {
                  block: v.VAL
                }, key);
    } else if (variant === "EnrichedTextBlock") {
      return JsxRuntime.jsx(EnrichedTextSection.make, {
                  block: v.VAL
                }, key);
    } else if (variant === "TeamMembersBlock") {
      return JsxRuntime.jsx(MeetTheTeam.make, {
                  block: v.VAL
                }, key);
    } else {
      return null;
    }
  };
  var content = pageContent !== undefined ? Belt_Array.mapWithIndex(pageContent.content_blocks, f) : null;
  var f_seo_meta = function (v) {
    return JsxRuntime.jsx(SeoMeta.make, {
                meta: v.VAL
              });
  };
  var seo_meta = pageContent !== undefined ? Belt_Option.mapWithDefault(pageContent.seo_meta, null, f_seo_meta) : null;
  return JsxRuntime.jsxs("div", {
              children: [
                seo_meta,
                JsxRuntime.jsx(AboutHeader.make, {}),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx(WhoWeAreSection.make, {}),
                      className: whoWeAreContainer
                    }),
                JsxRuntime.jsx(OurJourneySection.make, {}),
                JsxRuntime.jsx(MediaSection.make, {}),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx(OurValueSection.make, {}),
                        JsxRuntime.jsx(AboutJoinTeam.make, {})
                      ],
                      className: container
                    }),
                content
              ]
            });
}

var make = About;

var getServerSideProps = PageContentResolver.resolver;

var $$default = About;

export {
  Styles ,
  make ,
  getServerSideProps ,
  $$default ,
  $$default as default,
}
/* whoWeAreContainer Not a pure module */
